const FAV_PREFIX = '@@favorites/';

export const FAV_ACTION_TYPES = {
    TOGGLE_ITEM: `${FAV_PREFIX}TOGGLE_ITEM`,
    CLEAR_FAVORITES: `${FAV_PREFIX}CLEAR_FAVORITES`,
};

